import React from 'react';
import CheckmarkIcon from './CheckmarkIcon';

interface OptionButtonProps {
    value: string;
    label: string;
    isActive: boolean;
    onClick: (value: string) => void;
}

const OptionButton: React.FC<OptionButtonProps> = ({ value, label, isActive, onClick }) => {
    return (
        <button
            className={`option-btn ${isActive ? 'active' : ''}`}
            onClick={() => onClick(value)}
            type="button"
            aria-pressed={isActive}
            aria-label={label}
        >
            <span>{label}</span>
            {isActive && <div className="check-icon" aria-hidden="true"><CheckmarkIcon /></div>}
        </button>
    );
};

export default OptionButton;
